define('drops/matrix/matrix',[
    'jquery',
    'underscore',
    'lq',
    'lq/drop',
    'lq/style',
    'drops/matrix/matrixTablesSynchronizer',
    'lq/html',
    'lq/onlongpress'
], function ($, _, lq, Drop, Style, matrixTablesSynchronizer, html, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            rowHeaders: [],
            rowHeadersSort: [],
            columnHeaders: [{}],
            columnHeadersSort: [],
            columnContentAlignment: 'center',
            dataItems: [{}],
            fixedColumnHeaderTextOrientation: 'horizontal',
            columnHeaderTextOrientation: 'horizontal'
        }
    };

    var createCol = function ($colgroup, optionalWidth) {
        var $col = $('<col>')
            .appendTo($colgroup);
        if (optionalWidth)
            $col.css('width', optionalWidth);
    };

    var Matrix = function (options) {
        Drop.call(this, $('<div>'), defaults, options);

        this.$fixedHeaders = $('<table/>')
            .addClass('fixed-headers');
        this.$fixedHeadersWrapper = $('<div/>')
            .css({
                'float': 'left',
                'overflow': 'hidden'
            })
            .append(this.$fixedHeaders);

        this.$fixedRows = $('<table/>')
            .addClass('fixed-rows')
            .css('margin-bottom', '100px'); // leave some space for scrollbar and 'next page'-loader at the bottom
        this.$fixedRowsWrapper = $('<div/>')
            .css({
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                'overflow': 'hidden'
            })
            .append(this.$fixedRows);

        this.$dynamicHeaders = $('<table/>')
            .addClass('dynamic-headers');
        this.$dynamicHeadersWrapper = $('<div />')
            .css('overflow', 'hidden')
            .append($('<div />')
                .css({
                    'float': 'left',
                    'padding-right': '40px' // leave some space for the scrollbar
                })
                .append(this.$dynamicHeaders));

        this.$dynamicRows = $('<table/>')
            .addClass('dynamic-rows');
        this.$dynamicRowsWrapper = $('<div/>')
            .css({
                'overflow-x': 'auto',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            })
            .append(this.$dynamicRows);

        this.$matrix = $('<div />')
            .css({
                overflow: 'hidden',
                width: '100%',
                height: '100%'
            })
            .append(this.$fixedHeadersWrapper, this.$dynamicHeadersWrapper)
            .append($('<div />').css('clear', 'both'))
            .append(this.$fixedRowsWrapper, this.$dynamicRowsWrapper);

        this.$element
            .addClass('boxToBorderSize')
            .append(this.$matrix);

        Style.renderStyles(this, 'gridstyle-');

        this.loadedPages = 0;
        this.allData = null;

        var self = this;
        this.$dynamicRowsWrapper.on('scroll', function () {
            console.log(self.$dynamicRowsWrapper.scrollTop());
            self.$fixedRowsWrapper.scrollTop(self.$dynamicRowsWrapper.scrollTop());
            self.$dynamicHeadersWrapper.scrollLeft(self.$dynamicRowsWrapper.scrollLeft());
        });

        this.update();
    };

    Drop.extend(Matrix);

    Matrix.typeName = 'Matrix';

    Matrix.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        var self = this;
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) {
                self.loadedPages = 1;
                self.allData = data;
                self.update(data);
            },
            function (params) {
                self.decorateDataSourceData(params);
            });

        this.applyPosition();
    };

    Matrix.prototype.decorateDataSourceData = function (queryData, page) {
        if (!this.data.pageSize)
            return;

        queryData.pageSize = this.data.pageSize;
        queryData.page = page || 0;
    };

    Matrix.prototype.setColumnWidthBasedOnSettings = function (dynamicColumnCount) {
        var visibleRowHeaders = _.reject(this.data.rowHeaders, function (header) {
            return header.hide;
        });

        var $fixedRowsGroup = $('<colgroup>')
            .appendTo(this.$fixedRows);
        var $fixedHeadersGroup = $('<colgroup>')
            .appendTo(this.$fixedHeaders);

        _.each(visibleRowHeaders, function (rowHeader) {
            createCol($fixedRowsGroup, rowHeader.width);
            createCol($fixedHeadersGroup, rowHeader.width);
        });

        var $dynamicRowsGroup = $('<colgroup>')
            .appendTo(this.$dynamicRows);
        var $dynamicHeadersGroup = $('<colgroup>')
            .appendTo(this.$dynamicHeaders);

        var self = this;
        _(dynamicColumnCount).times(function () {
            createCol($dynamicRowsGroup, self.data.columnWidth);
            createCol($dynamicHeadersGroup, self.data.columnWidth);
        });

        if (this.data.columnWidth) {
            var totalWidth = {
                'table-layout': 'fixed',
                'width': dynamicColumnCount * this.data.columnWidth
            };
            this.$dynamicHeaders.css(totalWidth);
            this.$dynamicRows.css(totalWidth);
        } else {
            var autoWidth = {
                'table-layout': 'auto',
                'width': 'auto'
            };
            this.$dynamicHeaders.css(autoWidth);
            this.$dynamicRows.css(autoWidth);
        }
    };

    Matrix.prototype.update = function (data) {
        var self = this;
        var settings = this.data;

        data = data || {
            Outputs: [],
            Results: [],
            TotalResults: 0
        };

        this.$matrix.detach();

        this.$fixedHeaders
            .empty();
        this.$fixedRows
            .empty();
        this.$dynamicHeaders
            .empty();
        this.$dynamicRows
            .empty();

        var visibleRowHeaders = _.reject(settings.rowHeaders, function (header) { return header.hide; });

        // calculate unique row and column headers
        var uniqueRowHeaderGroups = _.groupBy(data.Results, function (dataItem) { return self.getRowKey(dataItem); });
        var uniqueColumnHeaderGroups = _.groupBy(data.Results, function (dataItem) { return self.getColumnKey(dataItem); });

        var dynamicColumnCount = _.keys(uniqueColumnHeaderGroups).length;
        self.setColumnWidthBasedOnSettings(dynamicColumnCount);

        var columnHeaderOutputs = _.pluck(settings.columnHeaders, 'output');
        var columnHeaderSortOutputs = _.compact(_.pluck(settings.columnHeadersSort, 'output'))
            .concat(columnHeaderOutputs);
        var columnKeysSorted = _.keys(uniqueColumnHeaderGroups).sort(function (key1, key2) {
            var dataItem1 = uniqueColumnHeaderGroups[key1][0];
            var dataItem2 = uniqueColumnHeaderGroups[key2][0];
            return self.compareDataItems(dataItem1, dataItem2, columnHeaderSortOutputs);
        });

        // build fixed header columns
        $('<tr>')
            .append(_.chain(settings.rowHeaders)
                .reject(function (header) {
                    return header.hide;
                })
                .map(function (rowHeader) {
                    var $label = $('<span />')
                        .text(rowHeader.label);

                    if (self.data.fixedColumnHeaderTextOrientation === 'vertical') {
                        $label.addClass('vertical-matrix-header');

                        if (self.data.enableHeadersHeight)
                            $label.css('height', self.data.headersHeight + 'px');
                    }


                    return $('<th>')
                        .append($label);
                })
                .value())
            .appendTo(this.$fixedHeaders);

        // build dynamic header columns
        $('<tr>')
            .append(_.map(columnKeysSorted, function(columnHeaderKey) {
                var columnHeaderGroup = uniqueColumnHeaderGroups[columnHeaderKey];
                var columnHeaderData = columnHeaderGroup[0];

                var headerText =
                    _.chain(settings.columnHeaders)
                        .filter(function(columnHeaderSettings) { return !columnHeaderSettings.hide; })
                        .pluck('output')
                        .map(function(visibleColumnHeaderOutput) { return columnHeaderData[visibleColumnHeaderOutput]; })
                        .value()
                        .join(' ');

                var $label = $('<span />')
                    .text(headerText);

                if (self.data.columnHeaderTextOrientation === 'vertical') {
                    $label.addClass('vertical-matrix-header');

                    if (self.data.enableHeadersHeight)
                        $label.css('height', self.data.headersHeight + 'px');
                }

                return $('<th>')
                    .append($label);
            }))
            .appendTo(this.$dynamicHeaders);

        // build rows with data
        var rowHeaderOutputs = _.pluck(settings.rowHeaders, 'output');
        var rowHeaderSortOutputs = _.compact(_.pluck(settings.rowHeadersSort, 'output'))
            .concat(rowHeaderOutputs);
        var rowKeysSorted = _.keys(uniqueRowHeaderGroups).sort(function (key1, key2) {
            var dataItem1 = uniqueRowHeaderGroups[key1][0];
            var dataItem2 = uniqueRowHeaderGroups[key2][0];
            return self.compareDataItems(dataItem1, dataItem2, rowHeaderSortOutputs);
        });

        var clickEventData = this.getEventDataFor('clicked');
        var fixedColumnClickEventData = this.getEventDataFor('fixedColumnClicked');

        _.each(rowKeysSorted, function (rowHeaderKey) {
            var rowHeaderGroup = uniqueRowHeaderGroups[rowHeaderKey];
            var firstItemInRowGroup = rowHeaderGroup[0];

            // build fixed row
            $('<tr>')
                .append(_.map(visibleRowHeaders, function (rowHeader) {
                    var fixColumnContent = firstItemInRowGroup[rowHeader.output];
                    var $fixedColumnCell = $('<td>')
                        .text(fixColumnContent);

                    var currentFixedColumnEventArg = settings.eventArgFixedColumn ? firstItemInRowGroup[settings.eventArgFixedColumn] : null;
                    self.applyEventTrigger('fixedColumnClicked', 'click', $fixedColumnCell, currentFixedColumnEventArg);

                    if (fixedColumnClickEventData.enabled)
                        $fixedColumnCell.addClass('clickable');

                    return $fixedColumnCell;
                }))
                .appendTo(self.$fixedRows);

            // build dynamic row
            $('<tr>')
                .append(_.map(columnKeysSorted, function (columnHeaderKey) {
                    // TODO: check/improve performance of data item lookup
                    var dataItem = _.find(rowHeaderGroup, function (rowGroupItem) { return self.getColumnKey(rowGroupItem) === columnHeaderKey; });
                    var $tableCell = $('<td>')
                        .css('text-align', self.data.columnContentAlignment)
                        .text(dataItem && dataItem[settings.dataItems[0].output] || '');

                    var currentBackgroundColor = dataItem && dataItem[settings.backgroundColorOutput];
                    if (currentBackgroundColor) {
                        $tableCell.css('background-color', currentBackgroundColor);
                    }

                    var currentTooltip = dataItem && dataItem[settings.tooltipOutput];
                    if (currentTooltip)
                        $tableCell.attr('title', html.strip(currentTooltip));

                    var currentEventArg = dataItem && dataItem[settings.eventArg];

                    new OnLongPress().applyLongPressOnElement($tableCell, self, currentEventArg);

                    if (clickEventData.enabled && (currentEventArg !== undefined || !settings.eventArg) || self.isEventEnabled('onLongPress')) {
                        $tableCell.addClass('clickable');
                    }

                    return $tableCell;
                }))
                .appendTo(self.$dynamicRows);
        });

        this.$element
            .append(this.$matrix);

        if (data.Results.length > 0)
            this.postUpdate();

        if (data.TotalResults > data.Results.length)
            this.renderLoadMoreButton(columnKeysSorted.length);
    };

    Matrix.prototype.postUpdate = function () {
        matrixTablesSynchronizer.syncFor(this);

        this.$dynamicHeadersWrapper
            .css('margin-left', this.$fixedHeadersWrapper.outerWidth() + 'px');

        this.$dynamicRowsWrapper
            .css({
                top: this.$dynamicHeadersWrapper.outerHeight() + 'px',
                left: this.$fixedHeadersWrapper.outerWidth() + 'px'
            });

        this.$fixedRowsWrapper
            .css({
                top: this.$dynamicHeadersWrapper.outerHeight() + 'px',
                width: this.$fixedHeadersWrapper.outerWidth() + 'px'
            })
            .scrollTop(0);

        this.$dynamicHeadersWrapper.scrollLeft(0);
    };

    Matrix.prototype.renderLoadMoreButton = function (numberOfDynamicColumns) {
        var self = this;
        var $loadMoreRow = $('<tr>')
            .appendTo(this.$dynamicRows);
        var $loadMoreCell = $('<td>')
            .attr('colspan', numberOfDynamicColumns)
            .appendTo($loadMoreRow);
        this.$loadMoreButton = $('<span>')
            .addClass('paging-button clickable')
            .text(this.data.nextPageText || 'Load more...')
            .on('click', function () { self.loadNextPage(); })
            .appendTo($loadMoreCell);
        Style.renderStyles(this, null, this.$loadMoreButton, this.data.nextPageStyle);
    };

    Matrix.prototype.loadNextPage = function () {
        if (this.loading)
            return;
        this.loading = true;
        //self.renderPreloader(); // maybe?

        var self = this;
        this.piping.queryDispatcher.dispatch(
            self.data.dataSource,
            function (newData) {
                self.loadedPages++;
                self.loading = false;
                //self.removePreloader(); // maybe?
                var allResults = self.allData.Results.concat(newData.Results);
                _.extend(self.allData, newData, { Results: allResults });
                self.update(self.allData);
            },
            function (params) {
                self.decorateDataSourceData(params, self.loadedPages);
            },
            function (error) {
                self.loading = false;
                //self.removePreloader(); // maybe?
            });
    };

    var KEY_SEPARATOR = '$';

    var getKey = function (resultItem, fieldNames) {
        var headerData = _.map(fieldNames, function(headerField) {
            return resultItem[headerField];
        });
        return headerData.join(KEY_SEPARATOR);
    };

    Matrix.prototype.getRowKey = function (resultItem) {
        var rowHeaderOutputs = _.pluck(this.data.rowHeaders, 'output');
        return getKey(resultItem, rowHeaderOutputs);
    };

    Matrix.prototype.getColumnKey = function (resultItem) {
        var columnHeaderOutputs = _.pluck(this.data.columnHeaders, 'output');
        return getKey(resultItem, columnHeaderOutputs);
    };

    Matrix.prototype.compareDataItems = function (dataItem1, dataItem2, fieldsToCompare) {
        return _.reduce(fieldsToCompare, function (previousResult, fieldName) {
            if (previousResult !== 0)
                return previousResult;

            if (dataItem1[fieldName] === dataItem2[fieldName])
                return 0;

            return dataItem1[fieldName] < dataItem2[fieldName] ? -1 : 1;
        }, 0);
    };

    return Matrix;
});
